import React from "react";
import styles from "./TheDao.module.css";
import dark from "./TheDaoDark.module.css";
import { Col, Row } from "antd";
const TheDao = ({ theme }) => {
  return (
    <div className={theme ? styles.outer : dark.outer}>
      <Row className={styles.dao_container}>
        <Col md={12} className={theme ? styles.dao_right : dark.dao_right}>
          <h1>THE DAO</h1> <br />
          <p className={theme ? styles.dao_p : dark.dao_p}>
            The DOS Punks DAO exists to buy and hoard art from new/emerging
            artists (focused on Glitch & Trash Art), and to promote the artists
            collected by the DAO. The DOS Punks DAO works to benefit the
            cryptoart community by collecting and holding art, not by generating
            profit for members.
          </p>
        </Col>
        <Col md={12}>
          <Row className={styles.imagesRow} gutter={[32, 32]}>
          <Col xs={12} md={12}>
            <img className={styles.image} src="https://gpmqvddbd6fkqvzmt4lyjpjlynxdkjc7vvohfpuolfly7i7xtkcq.arweave.net/M9kKjGEfiqhXLJ8XhL0rw241JF-tXHK-jllXj6P3moU/0300.png" alt="" />
          </Col>
          <Col xs={12} md={12}>
            <img className={styles.image} src="https://gpmqvddbd6fkqvzmt4lyjpjlynxdkjc7vvohfpuolfly7i7xtkcq.arweave.net/M9kKjGEfiqhXLJ8XhL0rw241JF-tXHK-jllXj6P3moU/0289.png" alt="" />
          </Col>
          <Col xs={12} md={12}>
            <img className={styles.image} src="https://gpmqvddbd6fkqvzmt4lyjpjlynxdkjc7vvohfpuolfly7i7xtkcq.arweave.net/M9kKjGEfiqhXLJ8XhL0rw241JF-tXHK-jllXj6P3moU/0288.png" alt="" />
          </Col>
          <Col xs={12} md={12}>
            <img className={styles.image} src="https://gpmqvddbd6fkqvzmt4lyjpjlynxdkjc7vvohfpuolfly7i7xtkcq.arweave.net/M9kKjGEfiqhXLJ8XhL0rw241JF-tXHK-jllXj6P3moU/0267.png" alt="" />
          </Col>
        </Row>
        </Col>
      </Row>
    </div>
  );
};

export default TheDao;
